module.exports = flarum.core.compat['components/LoadingModal'];